import { combineReducers, createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';

import * as fromAnyObject from './any-object.reducer';
import * as fromCommonObjectList from './common-object-list-uniqueId.reducer';

export const modelPortfoliosGetters = {
	getInitialState(): ModelPortfoliosState {
		return {
			modelPortfolios: fromCommonObjectList.initialState,
			modelPortfolioDetailsList: fromCommonObjectList.initialState,
			selectedModelPortfolioIds: fromAnyObject.initialState
		};
	},
	getAllModelPortfolios(): MemoizedSelector<object, Array<any>> {
		return createSelector(getModelPortfoliosState, fromCommonObjectList.getCommonObjectList);
	},
	getAllModelPortfoliosDetails(): MemoizedSelector<object, Array<any>> {
		return createSelector(getModelPortfolioDetailsListState, fromCommonObjectList.getCommonObjectList);
	},
	getSelectedModelPortfolioIds(): MemoizedSelector<object, any> {
		return createSelector(getSelectedModelPortfolioIdsState, fromAnyObject.getObject);
	}
};

export interface ModelPortfoliosState {
	modelPortfolios: fromCommonObjectList.CommonObjectListState;
	modelPortfolioDetailsList: fromCommonObjectList.CommonObjectListState;
	selectedModelPortfolioIds: fromAnyObject.AnyObjectState;
}

export function getInitialState(): ModelPortfoliosState {
	return {
		modelPortfolios: fromCommonObjectList.initialState,
		modelPortfolioDetailsList: fromCommonObjectList.initialState,
		selectedModelPortfolioIds: fromAnyObject.initialState
	};
}

export const ModelPortfoliosStateNames = {
	modelPortfolios: 'modelPortfolios',
	modelPortfolioDetailsList: 'modelPortfolioDetailsList',
	selectedModelPortfolioIds: 'selectedModelPortfolioIds'
};

const reducers = combineReducers({
	modelPortfolios: fromCommonObjectList.createReducerWithName(ModelPortfoliosStateNames.modelPortfolios),
	modelPortfolioDetailsList: fromCommonObjectList.createReducerWithName(ModelPortfoliosStateNames.modelPortfolioDetailsList),
	selectedModelPortfolioIds: fromAnyObject.createReducerWithName(ModelPortfoliosStateNames.selectedModelPortfolioIds)
});
export default reducers;

// get from state
export const getState = createFeatureSelector<ModelPortfoliosState>('modelPortfolios');

export const getModelPortfoliosState = createSelector(getState, state => state.modelPortfolios);

export const getModelPortfolioDetailsListState = createSelector(getState, state => state.modelPortfolioDetailsList);

export const getSelectedModelPortfolioIdsState = createSelector(getState, state => state.selectedModelPortfolioIds);
